import { Component, OnInit } from '@angular/core';
import { FormBuilderBasicInputComponentModel } from '../../models/form-builder-basic-input-component-model';

@Component({
  selector: 'tf-core-fb-basic-input-divider-input',
  templateUrl: './fb-basic-input-divider-input.component.html',
  styleUrls: ['./fb-basic-input-divider-input.component.css']
})
export class FbCoreBasicInputDividerInputComponent extends FormBuilderBasicInputComponentModel implements OnInit {
    public data = {
        component: null,
        hasChanges: false,
        viewType: 'default'
    };

    constructor() {
        super();
    }

    ngOnInit(): void {
        super.init();
    }

    public getClasses(): any {
        return [
            this.data.component.type,
            this.data.component.subtype,
            this.data.component.layout
        ];
    }
}
